<template>
  <div style="width: 100%">
    <WysiwygAddon
      :badge-count="badgeCount"
      :title="title"
      :register-addon="registerAddon"
      :icon="icon"
      :initial-active="initialActive"
    >
      <template v-slot:default="{ resetKey }">
        <slot :resetKey="resetKey" />
      </template>
    </WysiwygAddon>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import WysiwygAddon from "features/wysiwyg/addon/WysiwygAddon.vue"
import { WysiwygAddon as WysiwygAddonType } from "features/wysiwyg/addon/wysiwyg-addon.types"
import { RegisterWysiwygAddonFunction } from "features/wysiwyg/addon/wysiwyg-addon.types"
import {
  AddAddonDataFunction,
  CreateAddonDataFunction,
  RegisterPostFormAddonFunction,
  ResetPostFormAddonFunction,
  UpdateAddonDataFunction,
} from "features/posts/form/addon/post-form-addon.types"

export default defineComponent({
  name: "PostFormAddon",
  components: { WysiwygAddon },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    initialActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    registerWysiwygAddon: {
      type: Function as PropType<RegisterWysiwygAddonFunction>,
      required: true,
    },
    badgeCount: {
      type: Number,
      required: true,
    },
    registerPostFormAddon: {
      type: Function as PropType<RegisterPostFormAddonFunction>,
      required: true,
    },
    resetAddon: {
      type: Function as PropType<ResetPostFormAddonFunction>,
      required: false,
    },
    createAddonData: {
      type: Function as PropType<CreateAddonDataFunction>,
      required: true,
    },
    updateAddonData: {
      type: Function as PropType<UpdateAddonDataFunction>,
      required: true,
    },
    addAddonData: {
      type: Function as PropType<AddAddonDataFunction>,
      required: false,
    },
  },
  setup(props) {
    const registerAddon = (wysiwygAddon: WysiwygAddonType) => {
      props.registerWysiwygAddon(wysiwygAddon)

      const resetFunction = () => {
        wysiwygAddon.resetAddon()
        if (props.resetAddon) props.resetAddon()
      }
      props.registerPostFormAddon({
        createAddonData: props.createAddonData,
        updateAddonData: props.updateAddonData,
        addAddonData: props.addAddonData,
        resetAddon: resetFunction,
      })
    }

    return {
      registerAddon,
    }
  },
})
</script>
